import { useCheckout } from '@/storecontext/checkout/useCheckout';
import {
    ModuleSofaConfigurationProductItem,
    BaseProductItem,
    CheckOutDeliverable,
} from '../shared/api/server-apis';
import { DeliverableSelectItem } from '@/storecontext/basket/useDeliverables';
import { sortBy } from 'lodash';

export function useDeliverableLineItems() {
    const { basket, deliveryInfo } = useCheckout();
    const deliverableLineItems = (itemIds: number[]): (ModuleSofaConfigurationProductItem | BaseProductItem | DeliverableSelectItem)[] => {
        const lineItemIds = itemIds ?? [];
        return lineItemIds.map((id) => {
            return basket.value?.items.find(item => item.id === id) || {} as ModuleSofaConfigurationProductItem | BaseProductItem | DeliverableSelectItem;
        });
    };
    const deliverableLineItemsSortedByDeliveryDate = (deliverable: CheckOutDeliverable): BaseProductItem[] => {
        const info = deliveryInfo.value[deliverable.id];
        const sortOrder = info?.labelForItems?.map(label => label.itemId) ?? [];
        const lineItems = deliverableLineItems(deliverable.itemIds) as BaseProductItem[];
        const sortedLineItems = sortBy(lineItems, item => sortOrder.indexOf(item.id));
        return sortedLineItems;
    };

    return {
        deliverableLineItems,
        deliverableLineItemsSortedByDeliveryDate,
    };
}
